import React from 'react';
import { Box, Container, Typography, Link, Grid, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.grey[100],
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 2, md: 4 }}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="primary" gutterBottom>
              WATCH PASSION
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('footer.description')}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5, lineHeight: 1.7 }}>
              <strong>Forasassi Lucia – WatchPassion</strong><br />
              P.IVA: 01813530514<br />
              <Link href="mailto:Info@watchpassion.net" color="inherit">Info@watchpassion.net</Link>
            </Typography>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Quick Links
            </Typography>
            <Link component={RouterLink} to="/" color="inherit" display="block" sx={{ mb: 1 }}>Home</Link>
            <Link component={RouterLink} to="/mercato" color="inherit" display="block" sx={{ mb: 1 }}>
              {t('footer.marketplace')}
            </Link>
            <Link component={RouterLink} to="/contatti" color="inherit" display="block" sx={{ mb: 1 }}>
              {t('nav.contact')}
            </Link>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Social & Contatti
            </Typography>
            <Link href="https://www.instagram.com/watch_passion/?hl=it" target="_blank" rel="noopener noreferrer" color="inherit" display="block" sx={{ mb: 1 }}>
              Instagram
            </Link>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Legal links */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { xs: 1, sm: 2 }, justifyContent: 'center', mb: 1 }}>
          <Link component={RouterLink} to="/privacy-policy" variant="caption" color="text.secondary">
            Privacy Policy
          </Link>
          <Typography variant="caption" color="text.secondary">·</Typography>
          <Link component={RouterLink} to="/cookie-policy" variant="caption" color="text.secondary">
            Cookie Policy
          </Link>
          <Typography variant="caption" color="text.secondary">·</Typography>
          <Link component={RouterLink} to="/termini-e-condizioni" variant="caption" color="text.secondary">
            Termini e Condizioni
          </Link>
        </Box>

        <Typography variant="body2" color="text.secondary" align="center">
          {'© '}{new Date().getFullYear()}{' '}
          <Link color="inherit" href="/">Watch Passion</Link>
          {'. All rights reserved.'}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
